import { defineComponent as _defineComponent } from 'vue'
import i18n from '../../locales/index';
import { isMobile, isWeChat } from '../../utils/environment';
import { computed } from 'vue';
import { useBasicStore } from '../../stores/basic';
import { storeToRefs } from 'pinia';
import SvgIcon from './base/SvgIcon.vue';
import LogoOfPCInChineseBlackIcon from './icons/LogoOfPCInChineseBlackIcon.vue';
import LogoOfPCInChineseWhiteIcon from './icons/LogoOfPCInChineseWhiteIcon.vue';
import LogoOfMobileInChinese from './icons/LogoOfMobileInChinese.vue';
import LogoTitleOfMobileInChinese from './icons/LogoTitleOfMobileInChinese.vue';
import LogoInEnglish from './icons/LogoInEnglish.vue';
import LogoTitleInEnglish from './icons/LogoTitleInEnglish.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Logo',
  setup(__props) {

const basicStore = useBasicStore();

const { defaultTheme } = storeToRefs(basicStore);

const isEN = computed(() => !isWeChat && i18n.global.locale.value === 'en-US');
const isZH = computed(() => isWeChat || i18n.global.locale.value === 'zh-CN');
const isBlackTheme = computed(() => defaultTheme.value === 'black');
const isWhiteTheme = computed(() => defaultTheme.value === 'white');


return { __sfc: true,basicStore, defaultTheme, isEN, isZH, isBlackTheme, isWhiteTheme, isMobile }
}

})